import { getStrapiURL, getNamecardURL } from "./api-helpers";



export async function fetchAPI(path: string, datatag: string) {
    // Build request URL
    const requestUrl = `${getStrapiURL(`/api${path}`)}`;

    // Trigger API call
    const response = await fetch(requestUrl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        cache: "no-cache",
        next: { tags: [datatag] },
    });

    if (!response.ok) return null;

    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
        return await response.json(); // Parse the JSON if the Content-Type is JSON
    } else {
        return null;
    }
}

export async function fetchNamecardAPI(path: string, datatag: string) {
    const requestUrl = `${getNamecardURL(`${path}`)}`;
    const cacheTag = datatag || "default";

    const response = await fetch(requestUrl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        cache: "no-cache",
        next: { tags: [cacheTag] },
    });

    if (!response.ok) return null;

    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
        return await response.json(); // Parse the JSON if the Content-Type is JSON
    } else {
        return null;
    }
}

export async function fetchNamecardProfilePic(staffId: string): Promise<{ url: string } | null> {
    const requestUrl = `${getNamecardURL(`/profile/${staffId}/pic`)}`;
    
    try {
        return { url: requestUrl };
    } catch (error) {
        console.error("Error fetching profile picture:", error);
        return null;
    }
}
